var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveUpDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 15112",
    fill: "none",
    d: "M24 24H0V0h24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 956",
    d: "M12.333 3.979a.789.789 0 01.237.177l3.884 4.251a.862.862 0 01-.022 1.169.756.756 0 01-.546.231.765.765 0 01-.568-.253l-2.531-2.769v12.486a.789.789 0 11-1.577 0V6.785L8.687 9.551a.771.771 0 01-1.122.021.865.865 0 01-.019-1.169l3.868-4.232a.774.774 0 01.587-.272.75.75 0 01.332.08zm4.047 4.494l-3.885-4.249a.643.643 0 00-.2-.154.66.66 0 00-.29-.069.678.678 0 00-.513.24L7.624 8.473a.752.752 0 00-.193.52.752.752 0 01.193-.52l3.868-4.232a.678.678 0 01.513-.24.66.66 0 01.29.069.643.643 0 01.2.154l3.885 4.249a.752.752 0 01.193.52.752.752 0 00-.193-.522zm-5.07-1.941zm-2.7 2.953a.67.67 0 01-.976.02.668.668 0 00.976-.02zm6.777 0a.665.665 0 00.973.02.667.667 0 01-.973-.02z"
  })));
}
export default SvgMoveUpDesktop;